module.exports = __webpack_public_path__ + "static/img/sangong.a8200c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/sangong.jpg
// module id = SUAD
// module chunks = 0